import { render, staticRenderFns } from "./compare-tool.vue?vue&type=template&id=2032134b"
import script from "./compare-tool.vue?vue&type=script&lang=js"
export * from "./compare-tool.vue?vue&type=script&lang=js"
import style0 from "./compare-tool.vue?vue&type=style&index=0&id=2032134b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports